(function () {
  angular
    .module("akitabox.ui.dialogs.note.delete")
    .factory("DeleteNoteDialog", DeleteNoteDialog);

  /* @ngInject */
  function DeleteNoteDialog($log, $q, $mdDialog, $mdMedia) {
    var modal = {
      templateUrl: "app/core/ui/dialogs/note/delete/delete-note.dialog.html",
      controller: "DeleteNoteDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog, `options.locals.noteIDs` and `options.locals.building` are required
     *
     * @param  {Object}                 options     Dialog options
     * @return {Promise<Object>|Error}               Promise that resolves with the deleted notes
     */
    function show(options) {
      // Verify we have assetIDs and building locals
      if (
        !options ||
        !options.locals ||
        !options.locals.noteIDs ||
        !options.locals.building
      ) {
        $log.error(
          "DeleteNoteDialog: you must pass in noteIDs and building via locals"
        );
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
